import { VehicleTypeList } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
const vehicleTypeUtils = createArrayUtils(VehicleTypeList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:vehicleType',
    createDefaultValue: () => 'PKW', // TODO: default value is propably related to calculator?
});
export const vehicleUtils = {
    vehicleTypeUtils,
};
